export function AdminFilterBar({ children }: { children: React.ReactNode }) {
  return <div className="admin-filter-bar">{children}</div>;
}
